import React from "react"
import ReactDOM from "react-dom/client"
import "./index.css"
import App from "./App"
import reportWebVitals from "./reportWebVitals"
import { BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ModalContextProvider } from "./components/context/ModalContext"
import { AuthContextProvider } from "./components/context/AuthContext"
import { SessionAbilityProvider } from "./components/context/AbilityContext"

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement)
root.render(
    <BrowserRouter>
        <QueryClientProvider client={new QueryClient()}>
            <ModalContextProvider>
                <AuthContextProvider>
                    <SessionAbilityProvider>
                        <App />
                    </SessionAbilityProvider>
                </AuthContextProvider>
            </ModalContextProvider>
        </QueryClientProvider>
    </BrowserRouter>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
